import React, { useState, useEffect } from 'react';
import useFetchObjectByPost from '../../../../components/Hooks/useFetchObjectByPost';
import { sto } from '../../../../Context/InshData';
import { uri } from '../../../../help/Api';
import LoadingPage from '../../../../services/LoadingPage';
import AccountsSystem from './AccountsSystem';
const defaultAutos = {
  Branches: [],
}
export default function AccountsSystemCon() {

  const tb = {
    wait: true,
    Branches: true,
    costcenters: true,
    stor: sto,
    multiData: true,
    parms: {
      safe: -1,
      db_name: sto.db_name
    }
  }
  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(uri + 'Rept', tb);


  if (fetchAll || !AutoOptions?.Branches)
    return <LoadingPage />;

  return (
    <AccountsSystem {...{
      AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
    }
    } />
  );




};